module.exports = __webpack_public_path__ + "img/no-image.48ca6c4c.jpg";